<template>
  <v-dialog
    ref="dialog"
    v-model="modal"
    :return-value.sync="time"
    persistent
    width="290px"
    :readonly="readonly"
    :disabled="readonly"
  >
    <template v-slot:activator="{on, attrs}">
      <v-text-field
        :rules="rules"
        v-model="time"
        prepend-icon="mdi-clock-time-four-outline"
        readonly
        v-bind="attrs"
        v-on="on"
      ></v-text-field>
    </template>
    <v-time-picker
      v-if="modal"
      v-model="time"
      full-width
      :readonly="readonly"
      :disabled="readonly"
      :allowed-minutes="allowedMinutes"
    >
      <v-spacer></v-spacer>
      <v-btn text color="primary" @click="modal = false">
        Cancelar
      </v-btn>
      <v-btn text color="primary" @click="$refs.dialog.save(time)">
        Aceptar
      </v-btn>
    </v-time-picker>
  </v-dialog>
</template>

<script>
export default {
  name: 'timepicker',
  props: ['readonly', 'allowedMinutes', 'value', 'rules'],
  data() {
    return {
      modal: false,
      time: null,
    };
  },
  created() {
    this.time = this.value;
  },
  watch: {
    time() {
      this.$emit('input', this.time);
    },
    value() {
      this.time = this.value;
    },
  },
};
</script>

<style></style>
